import { render, staticRenderFns } from "./SalesZoneClient.vue?vue&type=template&id=67777d82"
import script from "./SalesZoneClient.vue?vue&type=script&lang=js"
export * from "./SalesZoneClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports